/**
 * Savings: a target, a current balance, and how far between them you are.
 *
 * Amounts are integer fils like the budget — same reasoning, same helpers.
 * PURE: no storage, no clock beyond what is passed in.
 */

export interface SavingsState {
  targetFils: number
  currentFils: number
  updatedAt: string | null
}

export interface SavingsView {
  targetFils: number
  currentFils: number
  remainingFils: number
  /** Clamped to 1 for the bar; `reached` says whether the target was met. */
  fraction: number
  reached: boolean
  updatedAt: string | null
}

export function emptySavings(): SavingsState {
  return { targetFils: 0, currentFils: 0, updatedAt: null }
}

export function savingsView(state: SavingsState): SavingsView {
  const target = Math.max(0, state.targetFils)
  const current = Math.max(0, state.currentFils)
  return {
    targetFils: target,
    currentFils: current,
    remainingFils: target - current,
    fraction: target > 0 ? Math.min(1, current / target) : 0,
    reached: target > 0 && current >= target,
    updatedAt: state.updatedAt,
  }
}
